import { supertypeClass, Bindable, Remoteable, Persistable, Supertype } from '@haventech/amorphic';
import { Assets } from '../../basicIllustration/templates/common/Assets';
import { HtmlPdfUtils } from '../../HtmlPdfUtils';
export class CssStyle {
  HtmlPdfHeaderStyle?: string = '';
}

class Header {
  HtmlPdfHeader: string = '';
  HtmlPdfTermInforceHeader: string = '';
  css: CssStyle = new CssStyle();
}

@supertypeClass({ toClient: false, toServer: true })
export class HtmlPdfHeader extends Bindable(Remoteable(Persistable(Supertype))) {
  private templateFolder = './apps/coverpath-common/classes/wholelife/components/header/templates/';
  constructor() {
    super();
  }

  Header;

  async getHeaderBody(product: string): Promise<string> {
    if (this.Header === undefined) {
      this.Header = await HtmlPdfUtils.getContent(this.templateFolder, new Header());
    }

    return this.Header.HtmlPdfHeader.replace(/{{URL_FOR_LOGO}}/g, Assets.MM_Logo).replace(/{{PRODUCT}}/g, product);
  }

  async getTermInforceHeaderBody(product: string): Promise<string> {
    if (this.Header === undefined) {
      this.Header = await HtmlPdfUtils.getContent(this.templateFolder, new Header());
    }

    return this.Header.HtmlPdfTermInforceHeader.replace(/{{URL_FOR_LOGO}}/g, Assets.MM_Logo).replace(
      /{{PRODUCT}}/g,
      product
    );
  }
}
